import { render, staticRenderFns } from "./ArmsRegArchiveApproval.vue?vue&type=template&id=7ed2521e&scoped=true&"
import script from "./ArmsRegArchiveApproval.vue?vue&type=script&lang=js&"
export * from "./ArmsRegArchiveApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed2521e",
  null
  
)

export default component.exports